import React from 'react'

const year = new Date().getFullYear()
export const NavFooterSchema = [
    {
        "text": <React.Fragment>
            {"© "+year+" Anthilia Capital Partners Sgr Spa"}
        </React.Fragment>,
    },
    {
        "text": "All rigths reserved",
    },
    {
        "text": <a href="mailto:middleoffice@anthilia.it">middleoffice@anthilia.it</a>,
    },
]
export const FooterCollapsed = null